import { Add } from '@mui/icons-material';
import { Button } from 'components/ui';
import type { AddFirmActionProps } from './AddFirmAction.props';

const AddFirmAction = ({ onClickHandler }: AddFirmActionProps) => (
  <Button onClick={onClickHandler} sizeVariant="compact" startIcon={<Add />} type="button" variant="text" visualVariant="primaryGhost">
    Add Firm
  </Button>
);

export default AddFirmAction;
